import { render, staticRenderFns } from "./sceltaScontriniDettaglio.vue?vue&type=template&id=f099fa1c"
import script from "./sceltaScontriniDettaglio.vue?vue&type=script&lang=js"
export * from "./sceltaScontriniDettaglio.vue?vue&type=script&lang=js"
import style0 from "./sceltaScontriniDettaglio.vue?vue&type=style&index=0&id=f099fa1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports